import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import { ImageProps } from "@lib/image";

export interface StrapiLinkDTO extends StrapiDynamicZoneComponentDTO {
  title: string;
  url: string;
  target: "_self" | "_blank" | "_parent" | "_top";
  file: StrapiMediaDTO;
  className: string;
}

export class LinkDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  title: string;
  url: string;
  target: "_self" | "_blank" | "_parent" | "_top";
  file: ImageProps;
  className: string;
}
